export const fontNames = {
  nunito: '"Nunito", "Helvetica", "Arial", sans-serif',
}
